import React from "react";
import { ReactComponent as RugSvg } from "../svg/rug.svg";

export default function RugIcon({ size = 64, color = "#32363F", ...props }) {
  return <RugSvg width={size} height={size} style={{ color }} {...props} />;
}
